import moment from 'moment-timezone';

export default {
  data () {
    return {
      params: '',
      switchList: [{
        slug: 'all',
        text: 'All',
        value: [
          null,
          null,
        ],
        active: true,
      }, {
        slug: 'today',
        text: 'Today',
        value: [
          moment().utc().startOf('day').format('X'),
          moment().utc().endOf('day').format('X'),
        ],
        active: false,
      }, {
        slug: 'last7',
        text: 'Last 7 days',
        value: [
          moment().utc().subtract(7, 'd').format('X'),
          moment().utc().format('X'),
        ],
        active: false,
      }, {
        slug: 'last30',
        text: 'Last 30 days',
        value: [
          moment().utc().subtract(30, 'd').format('X'),
          moment().utc().format('X'),
        ],
        active: false,
      }],
    };
  },
  mounted () {
    this.getSwitchList();
  },
  methods: {
    switchChange (el) {
      this.switchList.forEach((item, index) => {
        this.switchList[index].active = false;
        if (item.text == el.text) {
          this.switchList[index].active = true;
        }
      });
      this.$emit('dateSwitch', el);
    },
    getSwitchList () {
      this.$emit('getSwitchList', this.switchList);
    },
  },
};
